import { useEffect, useState } from 'react';
import { apiFetch } from '../config/api';
import StatTile, { StatSection } from './StatTile';

const HEALTH_COLORS = {
  healthy: '#166534',
  warning: '#92400e',
  critical: '#991b1b',
};

const HEALTH_LABELS = {
  healthy: 'Healthy',
  warning: 'Warning',
  critical: 'Critical',
};

function formatDateJoined(value) {
  if (!value) return null;
  const date = new Date(value);
  return Number.isNaN(date.getTime())
    ? null
    : date.toLocaleDateString(undefined, { year: 'numeric', month: 'short', day: 'numeric' });
}

// Per-school stats overview, shown on the school profile page.
export default function SchoolStatsOverview({ token, schoolId }) {
  const [stats, setStats] = useState(null);
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    if (!schoolId) return undefined;
    let cancelled = false;
    setLoading(true);
    setError('');

    apiFetch(`/schools/${schoolId}/stats`, {}, token)
      .then((res) => {
        if (!cancelled) setStats(res.data);
      })
      .catch((err) => {
        if (!cancelled) setError(err.message);
      })
      .finally(() => {
        if (!cancelled) setLoading(false);
      });

    return () => {
      cancelled = true;
    };
  }, [schoolId, token]);

  if (loading) return null;
  if (error) return <div className="sa-error">{error}</div>;
  if (!stats) return null;

  return (
    <div style={{ marginBottom: 24 }}>
      <StatSection title="Overview">
        <StatTile label="School Name" value={stats.school_name} />
        <StatTile
          label="Status"
          value={HEALTH_LABELS[stats.status] || stats.status}
          accent={HEALTH_COLORS[stats.status]}
        />
        <StatTile label="Subscription Status" value={stats.subscription_status} />
        <StatTile label="Date Joined" value={formatDateJoined(stats.date_joined)} />
      </StatSection>

      <StatSection title="Infrastructure">
        <StatTile label="Total Campuses" value={stats.total_campuses} />
        <StatTile label="Total Zones" value={stats.total_zones} />
      </StatSection>

      <StatSection title="Users">
        <StatTile label="Total Staff" value={stats.total_staff} />
        <StatTile label="Total Parents" value={stats.total_parents} />
        <StatTile label="Total Students" value={stats.total_students} />
        <StatTile label="Active Students" value={stats.active_students} />
        <StatTile label="Inactive Students" value={stats.inactive_students} />
      </StatSection>
    </div>
  );
}
